import React, { Dispatch, SetStateAction, useCallback } from "react"
import { AppointmentTypes, onSelectDateCallback } from "../../../Models/Types";
import SlotDate from "../../SlotDate/SlotDate.tsx";

type AppointmentTypeChoise = AppointmentTypes | null;

interface ModalAppointmentProps {
    setVisibleModal: Dispatch<SetStateAction<boolean>>
    onSelectDate: onSelectDateCallback,
    selectedType: AppointmentTypeChoise,
    customersQuantity: number,
    womanNumber: number,
    manNumber: number
}

const ModalAppointmentCheck: React.FC<ModalAppointmentProps> = ({ setVisibleModal, onSelectDate, selectedType, customersQuantity, womanNumber, manNumber }) => {

    const onReturnButtonClick = useCallback(() => {
        setVisibleModal(false)
    }, [selectedType, setVisibleModal])

    console.log("selectedType", selectedType)

    return <div id="modal-container" className="modal-container">
        <div className="modal-appointment-date">
            <div className="modal-header">
                <img onClick={onReturnButtonClick} id="back-to-form" className="icon" src="/calendario-appuntamenti/images/left-arrow.png" />
            </div>
            {selectedType !== null && <SlotDate
                womanNumber={womanNumber}
                manNumber={manNumber}
                appointmentType={selectedType}
                customersQuantity={customersQuantity === 0 ? 1 : customersQuantity}
                onSelectDate={onSelectDate}
            />}
        </div>
    </div>
}

export default ModalAppointmentCheck